import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_SUNLOCK_ASSIGN_LISTING_ID } from 'api/actionTypes';

export default async function assignSunlock(
  { state, apiClient },
  { sunlockId, listingId, triggeredBy },
) {
  typeCheck('sunlockId::PositiveNumber', sunlockId);
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('triggeredBy::NonEmptyString', triggeredBy);

  return apiClient.postWithState({
    action: SR_API_ACTION_SUNLOCK_ASSIGN_LISTING_ID,
    state: state,
    payload: {
      sunlockId,
      listingId,
      triggeredBy,
    },
  });
}
